import { useLazyQuery } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import ReportQuery from 'queries/inspection/report';

const ReportButton = ({ inspection }) => {
  const setError = useError();

  const [fetchReport, { loading }] = useLazyQuery(ReportQuery, {
    fetchPolicy: 'network-only',
  });

  const handleClick = async () => {
    try {
      const result = await fetchReport({ variables: { id: inspection.id } });
      const report = result?.data?.inspectionReport;

      if (!report) {
        setError('error.inspection.report');
        return;
      }

      const byteCharacters = atob(report.contentBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: report.mimeType });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = report.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch {
      setError('error.inspection.report');
    }
  };

  return (
    <Button color="primary" variant="outlined" disabled={loading} onClick={handleClick}>
      <FormattedMessage id="button.inspection.report" />
    </Button>
  );
};

export default ReportButton;
